var ja = {
  "Add Quantity Breaks to your product page": "商品ページに数量割引を追加",
  "Add Upsell.com to your ": "Upsell.comを追加: ",
  "All time": "全期間",
  "and select": "して選択",
  "button": "ボタン",
  "Cart drawer page": "カートドロワーページ",
  "Cart page": "カートページ",
  "Check status": "ステータスを確認",
  "Checkout page": "チェックアウトページ",
  "Click": "クリック",
  "Click on": "クリック",
  "Click the": "クリック：",
  "Custom slot": "カスタムスロット",
  "Custom slots": "カスタムスロット",
  "Custom Slots": "カスタムスロット",
  "contact support.": "サポートに連絡してください。",
  "from the right sidebar": "右側のサイドバーから",
  "Go to App Embeds": "アプリ埋め込みへ移動",
  "Go to your Cart drawer page": "カートドロワーページへ移動",
  "Go to your Cart page": "カートページへ移動",
  "Go to your Checkout page": "チェックアウトページへ移動",
  "Go to your Order status page": "注文ステータスページへ移動",
  "Go to your Post purchase page": "購入後ページへ移動",
  "Go to your Product page": "商品ページへ移動",
  "Go to your Thank you page": "サンキューページへ移動",
  "items": "アイテム",
  "in the left sidebar": "左側のサイドバーで",
  "Last 12 months": "過去12ヶ月",
  "Last 30 days": "過去30日",
  "Last 365 days": "過去365日",
  "Last 7 days": "過去7日",
  "Last 90 days": "過去90日",
  "Last month": "先月",
  "Last year": "昨年",
  "Make sure": "確認してください",
  "Need assistance? Contact our support team for help.": "お困りですか？サポートチームにお問い合わせください。",
  "Order status page": "注文ステータスページ",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "お客様の体験を向上させるため、現在アプリのメンテナンスを行っております。",
  "Post purchase page": "購入後ページ",
  "Product page": "商品ページ",
  "Save": "保存",
  "Scroll to the bottom and select": "一番下までスクロールして選択",
  "Select": "選択",
  "Success. Please continue.": "成功しました。続行してください。",
  "Thank you page": "サンキューページ",
  "The Upsell.com team.": "Upsell.comチーム。",
  "The Upsell.com widget is not placed on ": "Upsell.comウィジェットは",
  ". Please follow the steps above or ": "に配置されていません。上記の手順に従うか、",
  "Today": "今日",
  "toggle is on": "トグルがオンになっていることを",
  "Total": "合計",
  "under": "以下：",
  "We apologize for any inconvenience caused,": "ご不便をおかけして申し訳ありません、",
  "We apologize for any inconvenience caused.": "ご不便をおかけして申し訳ありません。",
  "We'll be done in a few minutes!": "数分で完了します！",
  "We're improving our services!": "サービスを改善しています！",
  "Widget already added": "ウィジェットはすでに追加されています",
  "Yesterday": "昨日",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "オンラインストアでウィジェットを有効にしましたが、Upsell エディターで保存していません",
  "You placed the widget on the ": "",
  ", but you didn't save it in Shopify editor. Please go back to ": "にウィジェットを配置しましたが、Shopifyエディタで保存していません。",
  " and save the changes.": "に戻り、変更を保存してください。"
};

export { ja as default };
//# sourceMappingURL=ja.json.js.map
